import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";
import Select from "react-select";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import {
  deleteData,
  getAlert,
  getDataWithJoin,
  insertData,
  parseCurrency,
  updateData,
  getDataWithComp,
  getData,
} from "../../../../utils/SamuiUtils";
import { useNavigate } from "react-router-dom";
import CurrencyInput from "react-currency-input-field";
import ItemTable from "../../../components/Content/ItemTable2";
import ItemTable2 from "../../../components/Content/ItemTable3";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  dataARtype,
  dataSaleman,
}) => {
  const [initialFormData, setInitialFormData] = useState({});
  const [formDetailList, setFormDetailList] = useState([]);
  const [formTransportList, setFormTransportList] = useState([]);
  const [creditTermError, setCreditTermError] = useState("");
  const navigate = useNavigate();

  const salemanOptions = [
    ...dataSaleman.map((emp) => ({
      label: emp.Emp_Name,
      value: emp.Emp_Name,
      Emp_Code: emp.Emp_Code,
      Emp_Tel: emp.Emp_Tel,
    })),
  ];

  if (
    formData.ar_refsalename &&
    !salemanOptions.find((opt) => opt.value === formData.ar_refsalename)
  ) {
    salemanOptions.unshift({
      label: formData.ar_refsalename,
      value: formData.ar_refsalename,
      Emp_Code: formData.ar_refsalecode || "",
      Emp_Tel: formData.ar_refsalephone || "",
    });
  }

  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        comp_id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        ar_id: "", // Int
        comp_id: window.localStorage.getItem("company"), // Int
        ar_code: "",
        ar_name: "",
        ar_type: "", // Int
        ar_shortname: "",
        ar_taxno: "",
        ar_add1: "",
        ar_add2: "",
        ar_add3: "",
        ar_province: "",
        ar_zipcode: "",
        ar_contact1: "",
        ar_contact2: "",
        ar_tel1: "",
        ar_tel2: "",
        ar_group: "",
        ar_area: "",
        ar_status: "Y",
        ar_credit: 0, // Int
        ar_vat: 0, // Int
        ar_discount: "",
        ar_branch: "",
        ar_bt_name: "",
        ar_addlan: "",
        ar_addlat: "",
        ar_credit_term: "",
        ar_credit_limit: "",
        ar_refsalename: dataSaleman[0]?.Emp_Name || "",
        ar_refsalecode: dataSaleman[0]?.Emp_Code || "",
        ar_refsalephone: dataSaleman[0]?.Emp_Tel || "",
      };
      // กำหนดค่าเริ่มต้นให้กับ form data
      setFormData(initialData);
      // กำหนดค่าเริ่มต้นให้กับ initial form data
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        ar_id: selectedData.AR_Id,
        comp_id: window.localStorage.getItem("company"),
        ar_code: selectedData.AR_Code,
        ar_name: selectedData.AR_Name,
        ar_type: selectedData.AR_Type,
        ar_shortname: selectedData.AR_ShortName,
        ar_taxno: selectedData.AR_TaxNo,
        ar_add1: selectedData.AR_Add1,
        ar_add2: selectedData.AR_Add2,
        ar_add3: selectedData.AR_Add3,
        ar_province: selectedData.AR_Province,
        ar_zipcode: selectedData.AR_Zipcode,
        ar_contact1: selectedData.AR_Contact1,
        ar_contact2: selectedData.AR_Contact2,
        ar_tel1: selectedData.AR_Tel1,
        ar_tel2: selectedData.AR_Tel2,
        ar_group: selectedData.AR_Group,
        ar_area: selectedData.AR_Area,
        ar_status: selectedData.AR_Status,
        ar_credit: parseCurrency(selectedData.AR_Credit, 10),
        ar_vat: parseCurrency(selectedData.AR_Vat, 10),
        ar_discount: selectedData.AR_Discount,
        ar_branch: selectedData.AR_Branch,
        ar_bt_name: selectedData.AR_BT_Name,
        ar_addlan: selectedData.AR_ADDLAN,
        ar_addlat: selectedData.AR_ADDLAT,
        ar_credit_term: selectedData.AR_Credit_Term,
        ar_credit_limit: selectedData.AR_Credit_Limit,
        ar_refsalecode: selectedData.AR_RefSaleCode,
        ar_refsalename: selectedData.AR_RefSaleName,
        ar_refsalephone: selectedData.AR_RefSalePhone,
      };
      setupdataContact(selectedData.AR_Id);
      setupdataTransport(selectedData.AR_Id);

      // อัปเดตค่าให้กับ form data
      setFormData(initialData);
      // อัปเดตค่าให้กับ initial form data
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  const setupdataContact = async (id) => {
    const arResult = await getData("Tb_Set_ARContact", `ar_id = ${id}`);
    if (arResult.length > 0) {
      const mapped = arResult.map((item) => ({
        contactName: item.contact_name,
        contactEmail: item.contact_email,
        contactPhone: item.contact_telephone,
      }));
      setFormDetailList(mapped);
    }
  };

  const setupdataTransport = async (id) => {
    const res = await getData("Tb_Set_ARTransport", `AR_Id = ${id}`);
    if (res.length > 0) {
      const mapped = res.map((item) => ({
        SetDefault: item.SetDefault,
        Add1: item.Add1,
        Add2: item.Add2,
        Add3: item.Add3,
        Province: item.Province,
        Zip_Code: item.Zip_Code,
        Tel1: item.Tel1,
        Tel2: item.Tel2,
        Contact1: item.Contact1,
        Contact2: item.Contact2,
        Add_Status: item.Add_Status,
      }));
      setFormTransportList(mapped);
    }
  };

  // ฟังก์ชันที่ใช้ในการเปลี่ยนค่าของข้อมูลในฟอร์ม
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "ar_taxno") {
      if (/^\d*$/.test(value) && value.length <= 13) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
    } else if (name === "ar_zipcode") {
      if (value.length <= 5) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
    } else if (name === "ar_group") {
      if (/^\d*$/.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
    } else if (name === "ar_credit") {
      const parsed = parseInt(value, 10);
      setFormData((prev) => ({
        ...prev,
        ar_credit: parsed,
        ar_credit_term: parsed === 1 ? prev.ar_credit_term : "", // reset ถ้าไม่ใช่ลูกค้าเครดิต
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleCurrencyChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInsertAR = async () => {
    try {
      const { ar_id, ...dataToInsert } = formData;
      const fieldMap = {
        ar_refsalephone: "AR_RefSalePhone",
        ar_refsalecode: "AR_RefSaleCode",
        ar_refsalename: "AR_RefSaleName",
        ar_credit_term: "AR_Credit_Term",
        ar_credit_limit: "AR_Credit_Limit",
        ar_bt_name: "AR_BT_Name",
        ar_branch: "AR_Branch",
        ar_discount: "AR_Discount",
        ar_vat: "AR_Vat",
        ar_credit: "AR_Credit",
        ar_status: "AR_Status",
        ar_area: "AR_Area",
        ar_group: "AR_Group",
        ar_tel2: "AR_Tel2",
        ar_tel1: "AR_Tel1",
        ar_contact2: "AR_Contact2",
        ar_contact1: "AR_Contact1",
        ar_zipcode: "AR_Zipcode",
        ar_province: "AR_Province",
        ar_add3: "AR_Add3",
        ar_add2: "AR_Add2",
        ar_add1: "AR_Add1",
        ar_taxno: "AR_TaxNo",
        ar_shortname: "AR_ShortName",
        ar_type: "AR_Type",
        ar_name: "AR_Name",
        ar_code: "AR_Code",
        comp_id: "Comp_Id",
        ar_addlan: "AR_ADDLAN",
        ar_addlat: "AR_ADDLAT",
      };
  
      const sanitizeData = (data) => {
        const sanitized = { ...data };
        sanitized.ar_credit = data.ar_credit === "" ? 0 : data.ar_credit;
        sanitized.ar_vat = data.ar_vat === "" ? 0 : data.ar_vat;
        sanitized.ar_discount = data.ar_discount === "" ? 0 : data.ar_discount;
        sanitized.ar_credit_term = data.ar_credit_term === "" ? 0 : data.ar_credit_term;
        sanitized.ar_credit_limit = data.ar_credit_limit === "" ? 0 : data.ar_credit_limit;
        sanitized.ar_type = data.ar_type === "" ? 12 : parseInt(data.ar_type);
        return sanitized;
      };
  
      const sanitizedData = sanitizeData(dataToInsert);
      const fields = Object.keys(sanitizedData)
        .map((key) => fieldMap[key] || key)
        .join(", ");
      const values = Object.values(sanitizedData);
  
      // INSERT ข้อมูลลง Tb_Set_AR
      const res = await insertData("Tb_Set_AR", fields, values);
      const insertedARId = parseInt(res.result?.recordsets[0]?.[0]?.insertedId);
  
      if (res?.status === "OK" && insertedARId) {
        const arResult = await getDataWithComp("Tb_Set_AR", `AND AR_Id = ${insertedARId}`);
        const insertedARCode = arResult?.[0]?.AR_Code;
  
        if (insertedARCode) {
          // ✅ contact: บันทึกได้แม้กรอกไม่ครบ (เว้นแต่เว้นทั้ง 3 ช่อง)
          for (const item of formDetailList) {
            const isAllContactEmpty =
              !item.contactName?.trim() &&
              !item.contactEmail?.trim() &&
              !item.contactPhone?.trim();
  
            if (isAllContactEmpty) continue;
  
            const contactFields = [
              "ar_id",
              "ar_code",
              "contact_name",
              "contact_email",
              "contact_telephone",
            ];
            const contactValues = [
              insertedARId,
              insertedARCode,
              item.contactName || "",
              item.contactEmail || "",
              item.contactPhone || "",
            ];
  
            const contactRes = await insertData(
              "Tb_Set_ARContact",
              contactFields.join(", "),
              contactValues
            );
  
            console.debug("🧾 contact insert result:", contactRes);
          }
  
          // 🚚 transport เหมือนเดิม
          let index = 0;
          for (const item of formTransportList) {
            const transportFields = [
              "AR_Id",
              "Line",
              "SetDefault",
              "Add1",
              "Add2",
              "Add3",
              "Province",
              "Zip_Code",
              "Tel1",
              "Tel2",
              "Contact1",
              "Contact2",
              "Add_Status",
            ];
            const transportValues = [
              insertedARId,
              index + 1,
              item.SetDefault || "N",
              item.Add1 || "",
              item.Add2 || "",
              item.Add3 || "",
              item.Province || "",
              item.Zip_Code || "",
              item.Tel1 || "",
              item.Tel2 || "",
              item.Contact1 || "",
              item.Contact2 || "",
              item.Add_Status || "Y",
            ];
  
            await insertData(
              "Tb_Set_ARTransport",
              transportFields.join(", "),
              transportValues
            );
            index++;
          }
  
          getAlert("OK", "บันทึกสำเร็จ");
          callInitialize();
        } else {
          getAlert("FAILED", "ไม่สามารถดึงข้อมูล AR ที่เพิ่มได้");
        }
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error inserting data:", error);
      getAlert(
        "FAILED",
        "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
    }
  };
  

  const formatValues = (data) => {
    const { ar_id, ...rest } = data;
    return {
      ...rest,
      ar_credit: data.ar_credit || 0,
      ar_vat: data.ar_vat || 0,
      ar_discount: data.ar_discount || 0,
      ar_credit_term: data.ar_credit_term || 0,
      ar_credit_limit: data.ar_credit_limit || 0,
    };
  };

  const handleUpdateAR = async () => {
    try {
      const where = { ar_id: formData.ar_id };
      const sanitizedData = formatValues(formData);
      const fieldMap = {
        ar_refsalephone: "AR_RefSalePhone",
        ar_refsalecode: "AR_RefSaleCode",
        ar_refsalename: "AR_RefSaleName",
        ar_credit_term: "AR_Credit_Term",
        ar_credit_limit: "AR_Credit_Limit",
        ar_bt_name: "AR_BT_Name",
        ar_branch: "AR_Branch",
        ar_discount: "AR_Discount",
        ar_vat: "AR_Vat",
        ar_credit: "AR_Credit",
        ar_status: "AR_Status",
        ar_area: "AR_Area",
        ar_group: "AR_Group",
        ar_tel2: "AR_Tel2",
        ar_tel1: "AR_Tel1",
        ar_contact2: "AR_Contact2",
        ar_contact1: "AR_Contact1",
        ar_zipcode: "AR_Zipcode",
        ar_province: "AR_Province",
        ar_add3: "AR_Add3",
        ar_add2: "AR_Add2",
        ar_add1: "AR_Add1",
        ar_taxno: "AR_TaxNo",
        ar_shortname: "AR_ShortName",
        ar_type: "AR_Type",
        ar_name: "AR_Name",
        ar_code: "AR_Code",
        comp_id: "Comp_Id",
        ar_addlan: "AR_ADDLAN",
        ar_addlat: "AR_ADDLAT",
      };
  
      const values = {};
      Object.keys(sanitizedData).forEach((key) => {
        const dbField = fieldMap[key] || key;
        values[dbField] = sanitizedData[key];
      });
  
      const res = await updateData("Tb_Set_AR", values, where);
  
      await deleteData("Tb_Set_ARContact", `WHERE ar_id = ${formData.ar_id}`);
      await deleteData("Tb_Set_ARTransport", `WHERE AR_Id = ${formData.ar_id}`);
  
      const arResult = await getDataWithComp(
        "Tb_Set_AR",
        `AND AR_Id = ${formData.ar_id}`
      );
      const insertedARCode = arResult?.[0]?.AR_Code;
  
      if (insertedARCode) {
        // ✅ แก้ตรงนี้: Contact สามารถกรอกบางช่องได้
        for (const item of formDetailList) {
          const isAllContactEmpty =
            !item.contactName?.trim() &&
            !item.contactEmail?.trim() &&
            !item.contactPhone?.trim();
  
          if (isAllContactEmpty) continue; // ❌ ข้ามถ้าทุกช่องว่าง
  
          const contactFields = [
            "ar_id",
            "ar_code",
            "contact_name",
            "contact_email",
            "contact_telephone",
          ];
          const contactValues = [
            formData.ar_id,
            insertedARCode,
            item.contactName || "",
            item.contactEmail || "",
            item.contactPhone || "",
          ];
  
          const contactRes = await insertData(
            "Tb_Set_ARContact",
            contactFields.join(", "),
            contactValues
          );
  
          console.debug("🧾 contact insert result:", contactRes);
        }
  
        // ⬇️ ส่วนของ ARTransport เหมือนเดิม
        let index = 0;
        for (const item of formTransportList) {
          const transportFields = [
            "AR_Id",
            "Line",
            "SetDefault",
            "Add1",
            "Add2",
            "Add3",
            "Province",
            "Zip_Code",
            "Tel1",
            "Tel2",
            "Contact1",
            "Contact2",
            "Add_Status",
          ];
          const transportValues = [
            formData.ar_id,
            index + 1,
            item.SetDefault || "N",
            item.Add1 || "",
            item.Add2 || "",
            item.Add3 || "",
            item.Province || "",
            item.Zip_Code || "",
            item.Tel1 || "",
            item.Tel2 || "",
            item.Contact1 || "",
            item.Contact2 || "",
            item.Add_Status || "Y",
          ];
  
          await insertData(
            "Tb_Set_ARTransport",
            transportFields.join(", "),
            transportValues
          );
  
          index++;
        }
  
        getAlert("OK", "บันทึกสำเร็จ");
      }
  
      if (res) {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize();
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };
  

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData("Tb_Set_AR", `WHERE AR_Id = ${selectedData.AR_Id}`);
          await deleteData(
            "Tb_Set_ARContact",
            `WHERE ar_id = ${formData.ar_id}`
          );
          await deleteData(
            "Tb_Set_ARTransport",
            `WHERE AR_Id = ${formData.ar_id}`
          );
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize(); // หลังจาก handleInsertAP, handleUpdateAP ทำงานเสร็จ callInitialize จะทำงานต่อ
          setFormData({
            ar_id: "", // Int
            comp_id: window.localStorage.getItem("company"), // Int
            ar_code: "",
            ar_name: "",
            ar_type: "", // Int
            ar_shortname: "",
            ar_taxno: "",
            ar_add1: "",
            ar_add2: "",
            ar_add3: "",
            ar_province: "",
            ar_zipcode: "",
            ar_contact: "",
            ar_contact2: "",
            ar_tel1: "",
            ar_tel2: "",
            ar_group: "",
            ar_refsalecode: "",
            ar_area: "",
            ar_status: "Y",
            ar_credit: 0, // Int
            ar_vat: 0, // Int
            ar_discount: "",
            ar_branch: "",
            ar_bt_name: "",
            ar_addlan: "",
            ar_addlat: "",
            ar_refsalename: "",
            ar_credit_term: "",
            ar_credit_limit: "",
          });
        }
      });
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleSubmit = async (e) => {
    try {
      if (!formData.ar_code || !formData.ar_name || !formData.ar_status) {
        getAlert(
          "WARNING",
          "โปรดกรอกข้อมูล รหัสลูกหนี้ ชื่อลูกหนี้ ประเภทลูกหนี้ สถานะ"
        );
        return;
      }

      if (formData.ar_credit === 1) {
        const creditTerm = parseInt(formData.ar_credit_term, 10);
        if (
          isNaN(creditTerm) ||
          creditTerm <= 0 ||
          !Number.isInteger(creditTerm)
        ) {
          getAlert(
            "WARNING",
            "กรุณาระบุระยะเวลาเครดิตลูกค้าเป็นเลขจำนวนเต็มมากกว่า 0"
          );
          return;
        }
      }

      if (
        formData.ar_code === initialFormData.ar_code &&
        formData.ar_name === initialFormData.ar_name &&
        formData.ar_type === initialFormData.ar_type &&
        formData.ar_shortname === initialFormData.ar_shortname &&
        formData.ar_taxno === initialFormData.ar_taxno &&
        formData.ar_add1 === initialFormData.ar_add1 &&
        formData.ar_add2 === initialFormData.ar_add2 &&
        formData.ar_add3 === initialFormData.ar_add3 &&
        formData.ar_province === initialFormData.ar_province &&
        formData.ar_zipcode === initialFormData.ar_zipcode &&
        formData.ar_contact === initialFormData.ar_contact &&
        formData.ar_contact2 === initialFormData.ar_contact2 &&
        formData.ar_tel1 === initialFormData.ar_tel1 &&
        formData.ar_tel2 === initialFormData.ar_tel2 &&
        formData.ar_group === initialFormData.ar_group &&
        formData.ar_refsalecode === initialFormData.ar_refsalecode &&
        formData.ar_area === initialFormData.ar_area &&
        formData.ar_status === initialFormData.ar_status &&
        formData.ar_credit === initialFormData.ar_credit &&
        formData.ar_vat === initialFormData.ar_vat &&
        formData.ar_discount === initialFormData.ar_discount &&
        formData.ar_branch === initialFormData.ar_branch &&
        formData.ar_bt_name === initialFormData.ar_bt_name &&
        formData.ar_addlat === initialFormData.ar_addlat &&
        formData.ar_addlan === initialFormData.ar_addlan &&
        formData.ar_refsalename === initialFormData.ar_refsalename &&
        formData.ar_credit_term === initialFormData.ar_credit_term &&
        formData.ar_credit_limit === initialFormData.ar_credit_limit &&
        formData.ar_refsalephone === initialFormData.ar_refsalephone
      ) {
        getAlert(
          "WARNING",
          "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
        );
        return;
      }
      if (mode === "I") {
        await handleInsertAR();
      } else if (mode === "U") {
        await handleUpdateAR();
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const checkArCode = async () => {
    const { item_id, ...dataToInsert } = formData;

    const resItemCode = await getDataWithJoin(
      `a.*`,
      `[dbo].[Tb_Set_AR] AS a`,
      `WHERE a.AR_Code = '${formData.ar_code}'`,
      ""
    );

    if (resItemCode && resItemCode.length > 0) {
      getAlert("FAILED", "มีรหัสลูกหนี้แล้ว");
      setFormData((prev) => ({ ...prev, ar_code: "" }));
    } else {
      getAlert("SUCCESS", "รหัสลูกหนี้นี้สามารถใช้ได้");
    }
  };

  const handleChangeDetail = (index, field, value) => {
    setFormDetailList((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const handleChangeSaleman = (e) => {
    const { value } = e.target;

    const selected = dataSaleman.find((emp) => emp.Emp_Name === value);

    if (selected) {
      setFormData((prev) => ({
        ...prev,
        ar_refsalename: selected.Emp_Name || "",
        ar_refsalephone: selected.Emp_Tel || "",
        ar_refsalecode: selected.Emp_Code || "",
      }));
    } else {
      // กรณีไม่พบใน dataSaleman
      setFormData((prev) => ({
        ...prev,
        ar_refsalename: "",
        ar_refsalephone: "",
        ar_refsalecode: "",
      }));
    }
  };

  const handleChangeDetailTransport = (index, field, value) => {
    setFormTransportList((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/debtor" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container p-4" style={{ maxWidth: "2169px" }}>
        <div className="card shadow-sm ">
          <div className="card-body">
            <div className="row g-3 mt-1 px-3">
              <div className="col-md-6">
                <label className="">รหัสลูกหนี้</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_code"
                  value={formData.ar_code || ""}
                  onBlur={mode !== "U" ? checkArCode : undefined}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6">
                <label className="">เลขภาษี</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_taxno"
                  value={formData.ar_taxno || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">ชื่อลูกหนี้</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_name"
                  value={formData.ar_name || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">ชื่อย่อ</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_shortname"
                  value={formData.ar_shortname || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">ประเภทลูกหนี้</label>
                {/* <input
              type="number"
              className="form-control input-spacing"
              name="ar_type"
              value={formData.ar_type || ""}
              onChange={handleChange}
            /> */}
                <div class="input-group">
                  <select
                    className="form-select"
                    name="ar_type"
                    value={formData.ar_type}
                    onChange={handleChange}
                    style={{ color: "black" }}
                    disabled={dataARtype.length <= 0}
                  >
                    {dataARtype.map((type, index) => (
                      <option key={index} value={type.ARType_Id}>
                        {type.ARType_Name}
                      </option>
                    ))}
                  </select>
                  {dataARtype.length <= 0 ? (
                    <div class="input-group-append">
                      <button
                        onClick={() => navigate("/ARtype")}
                        class="btn btn-lg text-white"
                        style={{
                          padding: "12px",
                          borderRadius: "0 5px 5px 0",
                          backgroundColor: "#EF6C00",
                        }}
                        type="button"
                      >
                        +
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="col-md-3 mt-2">
                <label className="">กลุ่ม</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_group"
                  value={formData.ar_group || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">ที่อยู่ 1</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_add1"
                  value={formData.ar_add1 || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">ที่อยู่ 2</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_add2"
                  value={formData.ar_add2 || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">ที่อยู่ 3</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_add3"
                  value={formData.ar_add3 || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">จังหวัด</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_province"
                  value={formData.ar_province || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">รหัสไปรษณีย์</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_zipcode"
                  value={formData.ar_zipcode || ""}
                  onChange={handleChange}
                />
              </div>
              {/* <div className="col-md-3 mt-2">
                <label className="">ติดต่อ</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_contact1"
                  value={formData.ar_contact1 || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">ติดต่อ 2</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_contact2"
                  value={formData.ar_contact2 || ""}
                  onChange={handleChange}
                />
              </div> */}
              <div className="col-md-3 mt-2">
                <label className="">พื้นที่</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_area"
                  value={formData.ar_area || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">สาขา</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_branch"
                  value={formData.ar_branch || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">ชื่อสาขา</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_bt_name"
                  value={formData.ar_bt_name || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">เบอร์โทร</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_tel1"
                  value={formData.ar_tel1 || ""}
                  onChange={handleChange}
                  maxLength="100"
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">เบอร์โทร 2(Fax)</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_tel2"
                  value={formData.ar_tel2 || ""}
                  onChange={handleChange}
                  maxLength="100"
                />
              </div>
              {/* <div className="col-md-3 mt-2">
                <label className="">รหัสอ้างอิงการขาย</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_refsalecode"
                  value={formData.ar_refsalecode || ""}
                  onChange={handleChange}
                  maxLength={20}
                />
              </div> */}
              <div className="col-md-3 mt-2">
                <label className="">Saleman</label>
                <Select
                  options={salemanOptions}
                  value={
                    salemanOptions.find(
                      (opt) => opt.value === formData.ar_refsalename
                    ) || null
                  }
                  onChange={(selected) => {
                    if (selected) {
                      setFormData((prev) => ({
                        ...prev,
                        ar_refsalename: selected.value,
                        ar_refsalecode: selected.Emp_Code,
                        ar_refsalephone: selected.Emp_Tel,
                      }));
                    } else {
                      setFormData((prev) => ({
                        ...prev,
                        ar_refsalename: "",
                        ar_refsalecode: "",
                        ar_refsalephone: "",
                      }));
                    }
                  }}
                  placeholder="เลือกพนักงานขาย"
                  isClearable
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">Saleman tel</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_refsalephone"
                  value={formData.ar_refsalephone || ""}
                  onChange={handleChange}
                  maxLength={50}
                />
              </div>

              <div className="col-md-3 mt-2">
                <label className="">ละติจูด</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_addlat"
                  value={formData.ar_addlat || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">ลองติจูด</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ar_addlan"
                  value={formData.ar_addlan || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">การลดราคา</label>
                <CurrencyInput
                  maxLength={10}
                  decimalsLimit={2}
                  decimalScale={2}
                  allowNegativeValue={false}
                  className="form-control input-spacing text-end"
                  name="ar_discount"
                  value={formData.ar_discount || ""}
                  onValueChange={(value, name) =>
                    handleCurrencyChange(value, name)
                  }
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">ภาษีมูลค่าเพิ่ม</label>
                <CurrencyInput
                  maxLength={10}
                  allowNegativeValue={false}
                  className="form-control input-spacing text-end"
                  name="ar_vat"
                  value={formData.ar_vat || ""}
                  onValueChange={(value, name) =>
                    handleCurrencyChange(value, name)
                  }
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">เครดิต</label>
                <select
                  className="form-select"
                  name="ar_credit"
                  value={formData.ar_credit || ""}
                  onChange={handleChange}
                >
                  <option value="">-- กรุณาเลือกประเภทลูกค้า --</option>
                  <option value="1">ลูกค้าเครดิต</option>
                  <option value="2">ลูกค้าเงินสด</option>
                </select>
              </div>

              <div className="col-md-3 mt-2">
                <label className="">ระยะเวลาเครดิตลูกค้า</label>
                <input
                  type="number"
                  className="form-control input-spacing text-end"
                  name="ar_credit_term"
                  value={formData.ar_credit_term || ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (formData.ar_credit === 1) {
                      const intValue = parseInt(value, 10);

                      if (
                        value === "" ||
                        isNaN(intValue) ||
                        intValue <= 0 ||
                        !Number.isInteger(intValue)
                      ) {
                        setFormData({ ...formData, ar_credit_term: value });
                        setCreditTermError("กรุณากรอกจำนวนเต็มมากกว่า 0");
                      } else {
                        setFormData({ ...formData, ar_credit_term: intValue });
                        setCreditTermError(""); // เคลียร์เมื่อถูกต้อง
                      }
                    } else {
                      setFormData({ ...formData, ar_credit_term: "" });
                      setCreditTermError("");
                    }
                  }}
                  disabled={formData.ar_credit !== 1}
                  min="1"
                  step="1"
                  placeholder="กรอกจำนวนวัน"
                />
                {formData.ar_credit === 1 && creditTermError && (
                  <small className="text-danger">{creditTermError}</small>
                )}
              </div>

              <div className="col-md-3 mt-2">
                <label className="">ยอดเครดิตลูกค้า</label>
                <CurrencyInput
                  maxLength={10}
                  allowNegativeValue={false}
                  className="form-control input-spacing text-end"
                  name="ar_credit_limit"
                  value={formData.ar_credit_limit || ""}
                  onValueChange={(value, name) =>
                    handleCurrencyChange(value, name)
                  }
                />
              </div>

              <div className="col-md-3 mt-2">
                <label className="">สถานะ</label>
                <select
                  className="form-select"
                  name="ar_status"
                  value={formData.ar_status || "Y"}
                  onChange={handleChange}
                  style={{ color: "black" }}
                >
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
            </div>
            <div style={{ overflowY: "auto", maxHeight: "500px" }}>
              <ItemTable
                formDetailList={formDetailList}
                handleChangeDetail={handleChangeDetail}
                setFormDetailList={setFormDetailList}
                disabled={false}
              />
              <ItemTable2
                formDetailList={formTransportList}
                handleChangeDetail={handleChangeDetailTransport}
                setFormDetailList={setFormTransportList}
                disabled={false}
              />
            </div>
            <div className="row mt-4">
              {mode !== "I" ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {/* ปุ่มลบ */}
                  <button
                    onClick={() => handleDelete()}
                    type="button"
                    className="btn btn-lg shadow text-white"
                    style={{
                      width: "8%",
                      backgroundColor: "#dc3545",
                      fontSize: "16px",
                    }}
                  >
                    ลบ
                  </button>

                  {/* กลุ่มปุ่มยกเลิก และบันทึก */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    <button
                      onClick={() => (window.location.href = "/debtor")}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#000000",
                        fontSize: "16px",
                      }}
                    >
                      ยกเลิก
                    </button>
                    <button
                      onClick={() => handleUpdateAR()}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#EF6C00",
                        fontSize: "16px",
                      }}
                    >
                      บันทึก
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex" }}>
                  <FormAction
                    onSubmit={handleSubmit}
                    onUpdate={handleSubmit}
                    onDelete={handleDelete}
                    mode={mode}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
